import { Routes, Route, Navigate } from 'react-router-dom';
import { GetQuote } from '../get-quote/GetQuote';
import { VolumeTL } from '../volume-tl/VolumeTL';
import { QuotesGrid } from '../quotes-grid/QuotesGrid';
import { UserModel } from '../../modules/auth/models/UserModel';
import { useSelector, shallowEqual } from 'react-redux';
import { RootState } from '../../../setup/redux/RootReducer';
import { Drayage } from '../drayage/Drayage';
import SpotQuote from '../spot-quote/SpotQuote'

export const Quote = () => {

  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  
  return (
    <Routes>
      {
        user?.allowQuoting ? 
        <>
          {
            user?.enabledVendors?.filter(vendor => vendor.type !== "DRAY")?.length > 0 ? 
            <>
              <Route
                path='get-quote'
                element={ <GetQuote/> }
              />
              <Route
                path='get-quote/:id'
                element={ <GetQuote/> }
              />
            </>
            : null
          }
          {
            user?.enabledVendors?.filter(vendor => vendor.type === "DRAY")?.length ? 
            <>
              <Route
                path='drayage'
                element={ <Drayage/> }
              />
              <Route
                path='drayage/:id'
                element={ <Drayage/> }
              />
            </>
            : null
          }
          {/* {
            user?.allowBatchQuoting ? 
              <Route
                path='batch-quoting'
                element={ <BatchQuoting/> }
              />
            : null
          } */}
          <Route
            path='grid-quotes'
            element={ <QuotesGrid/> }
          />
          <Route
            path='spot-quote'
            element={ <SpotQuote/> }
          />
        </> :  <Route path='*' element={<Navigate to='/home' />} />
      }
    </Routes>
  )
}